import type { TabsListProps } from '@base-ui/react';

import { Tabs as BaseTabs } from '@base-ui/react';

import { clsxs } from '~/styles/utils';

import { indicatorStyle, tabListStyle } from './Tabs.css';

type Props = TabsListProps;

export const TabsList = ({ children, ...delegated }: Props) => {
  return (
    <BaseTabs.List {...delegated} className={clsxs(tabListStyle, delegated.className)}>
      {children}

      <BaseTabs.Indicator className={indicatorStyle} />
    </BaseTabs.List>
  );
};
